import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { config } from "../../config/config";

export const getSpecialities = createAsyncThunk(
  "Specialities/getActive",
  async (_, thunkAPI) => {
    try {
      const { data } = await axios.get(
        `${config.base.url}/v1/user/specialities/getSpecialties`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to fetch active Specialities"
      );
    }
  }
);

export const getSingleSpecialities = createAsyncThunk(
  "Specialities/getSingle",
  async (id, thunkAPI) => {
    try {
      const { data } = await axios.get(
        `${config.base.url}/v1/user/specialities/getSingleSpecialties/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to fetch specialty details"
      );
    }
  }
);

export const getSubSpecialities = createAsyncThunk(
  "Specialities/getSingle",
  async (id, thunkAPI) => {
    try {
      const { data } = await axios.get(
        `${config.base.url}/v1/user/specialities/get_subSpecialtybySpecialty/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to fetch specialty details"
      );
    }
  }
);
